import { useEffect, useState } from 'react'
import _ from 'lodash'
import { HexColorPicker } from "react-colorful"
import { getDominantColor } from "@rtcoder/dominant-color"

import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'

import dataSelector from '/components/editor/apple/data-selector'


const WizardPallette = ({ passTypeData, setPrevButtonState, setNextButtonState, template, instanceData, scannerInstanceData, model, setModel, objectData, setObjectData, classData, setClassData }) => {

  const [googleSource, setGoogleSource] = useState("class")

  useEffect(() => {
    setPrevButtonState("enabled")
    setNextButtonState("enabled")
    if (objectData.hexBackgroundColor) setGoogleSource("object")
  }, [])

  const setColour = (item, colour) => {

    let m = _.cloneDeep(model)
    _.set(m, item, colour)
    setModel(m)

    if (item === "backgroundColor") {
      if (googleSource === "class") {
        let c = _.cloneDeep(classData)
        _.set(c, "hexBackgroundColor", colour)
        setClassData(c)
      } else {
        let o = _.cloneDeep(objectData)
        _.set(o, "hexBackgroundColor", colour)
        setObjectData(o)
      }
    }
  }


  const setColourFromImage = source => {

    const imageUrl = dataSelector({ template, instanceData, scannerInstanceData, path: `meta.images.${source}` })

    const img = { src: imageUrl }

    getDominantColor(img, {
      colorFormat: "hex",
      callback: colour => {
        setColour("backgroundColor", colour)
      }
    })
  }

  return (
    <div className="mb-10 ml-10">
      <Typography variant="h3" sx={{ p: 2 }}>Pass Colours</Typography>

      <div className='flex flex-row gap-5 justify-between'>

        <div className="mb-2">
          <Button variant="outlined" className="w-full" onClick={() => setColourFromImage("logo")}>Set BG Colour from Logo</Button>
        </div>

        {!!template.meta.images.strip &&
          <div className="mb-2">
            <Button variant="outlined" className="w-full" onClick={() => setColourFromImage("strip")}>Set BG Colour from Strip Image</Button>
          </div>
        }

      </div>

      <hr />

      <div className="flex flex-wrap gap-4 w-full justify-between">
        <AppleColourPicker item="backgroundColor" model={model} setColour={setColour} useColours={passTypeData.wizard_data.colours} />
        <AppleColourPicker item="foregroundColor" model={model} setColour={setColour} useColours={passTypeData.wizard_data.colours} />
        <AppleColourPicker item="labelColor" model={model} setColour={setColour} useColours={passTypeData.wizard_data.colours} />
        <AppleColourPicker item="stripColor" model={model} setColour={setColour} useColours={passTypeData.wizard_data.colours} />
      </div>
    </div>
  )
}

export default WizardPallette

const itemLabels = {
  backgroundColor: "Background",
  foregroundColor: "Foreground",
  labelColor: "Label",
  stripColor: "Strip"
}

const AppleColourPicker = ({ item, model, setColour, useColours }) => {

  const [newColour, setNewColour] = useState(model[item])

  useEffect(() => {
    if (/\#?[0-9a-fA-F]{6}/.test(newColour)){
      if (/\#[0-9a-zA-Z]{6}/.test(newColour))
        setColour(item,newColour)
      else
        setColour(item,"#" + newColour)
    }
  },[newColour])

  if (useColours.includes(item)) return (
    <div>
      <Typography variant="h6" sx={{ p: 2 }}>
        <div className="flex flex-col w-full justify-between">
          <div>{itemLabels[item]} Colour</div>
          <TextField value={newColour} sx={{ width: 100 }} onChange={e => setNewColour(e.target.value)} />
        </div>
      </Typography>
      <HexColorPicker color={model[item]} onChange={c => setColour(item, c)} />
    </div>
  )
}